import React from 'react'
import { FolderOpen, OndemandVideo } from '@mui/icons-material'
import { Button, Card, Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import * as category from '../../appRedux/actions/category'
import * as common from '../../appRedux/actions/common'
import * as router from '../../constants/router'
import useStyles from './styles'

function ProductBox(props) {
    const classes = useStyles()
    let type = props.type || ''
    let dirType = props.dirType || 'video'
    let categoryId = props.categoryId || ''

    const productBoxClick = (id) => {
        if (type === '') {
            props.redirectAction(router.CATEGORY_DETAILS + id)
        }
        else if (type === 'subdir') {
            props.redirectAction(router.CATEGORY_DETAILS + categoryId + id)
            props.categoryDetailsAction(categoryId + id)
        }
    }

    const getVideoLink = () => {
        if (dirType === 'video' && props.video !== '') return props.video
        return '#'
    }

    const getButtonTarget = () => {
        if (dirType === 'video' && props.video !== '') return '_blank'
        return ''
    }

    return (
        <React.Fragment>
            <Card className={classes.card} onClick={() => productBoxClick(props.id)}>
                <Grid>
                    <img src={process.env.REACT_APP_IMAGE + props.image} alt="dobande" className={classes.img} />
                </Grid>
                <Grid>
                    <Button
                        href={getVideoLink()}
                        target={getButtonTarget()}
                        endIcon={dirType === 'video' ? <OndemandVideo color='primary' /> : <FolderOpen color='primary' />}
                        fullWidth
                        color="secondary"
                        variant='contained'
                        size='large'>
                        <Typography variant='subtitle1' className={classes.content}>
                            {props.title || ''}
                        </Typography>
                    </Button>
                </Grid>
            </Card>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (route) => dispatch(common.redirectAction(route)),
        loadingPageAction: (data) => dispatch(common.loadingPageAction(data)),
        categoryDetailsAction: (id) => dispatch(category.categoryDetailsAction(id)),
        categoryDetailsVideoAction: (categoryId, categoryDetailsId) => dispatch(category.categoryDetailsVideoAction(categoryId, categoryDetailsId))

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductBox)
